// CNPJ contract v1 — Receita Federal: ASCII minus 48, modulo 11.
// Keep implementations aligned; the workspace contract tests exercise every copy.
export function normalizeCnpj(value) {
  // Do not coerce numbers: leading zeroes may already have been lost.
  if (typeof value !== 'string') return '';
  return value.replace(/[.\/\-\s]/g, '').replace(/[a-z]/g, char => char.toUpperCase());
}

export function cnpjValidationError(value) {
  const normalized = normalizeCnpj(value);
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(normalized)) return 'CNPJ_FORMAT';
  if (/^(\d)\1{13}$/.test(normalized)) return 'CNPJ_DV';
  let base = normalized.slice(0, 12);
  for (const weights of [[5,4,3,2,9,8,7,6,5,4,3,2], [6,5,4,3,2,9,8,7,6,5,4,3,2]]) {
    const sum = weights.reduce((total, weight, index) => total + (base.charCodeAt(index) - 48) * weight, 0);
    const remainder = sum % 11;
    base += String(remainder < 2 ? 0 : 11 - remainder);
  }
  return base === normalized ? null : 'CNPJ_DV';
}

export function isValidCnpj(value) {
  return cnpjValidationError(value) === null;
}

export function formatCnpj(value) {
  const normalized = normalizeCnpj(value);
  // Partial input is allowed for typing; invalid/overlong input is not truncated.
  if (!/^[A-Z0-9]{0,14}$/.test(normalized)) return normalized;
  return normalized.replace(/^(.{2})(.+)$/, '$1.$2')
    .replace(/^(.{6})(.+)$/, '$1.$2')
    .replace(/^(.{10})(.+)$/, '$1/$2')
    .replace(/^(.{15})(.+)$/, '$1-$2');
}

export const CNPJ_MESSAGE = 'CNPJ inválido: informe 12 letras ou números e 2 dígitos verificadores válidos.';

export function isValidCpfOrCnpj(value) {
  const normalized = normalizeCnpj(value);
  if (normalized.length !== 11) return isValidCnpj(value);
  if (!/^[0-9]{11}$/.test(normalized) || /^(\d)\1{10}$/.test(normalized)) return false;
  for (const size of [9, 10]) {
    let sum = 0;
    for (let index = 0; index < size; index++) sum += Number(normalized[index]) * (size + 1 - index);
    const digit = (sum * 10) % 11 % 10;
    if (digit !== Number(normalized[size])) return false;
  }
  return true;
}
